import App from "./App.svelte";

const app = new App({
  target: document.getElementById("eazwv-tag-eep"),
});

export default app;
